export default __webpack_public_path__ + "static/media/NIAS0400.34I-29078_-16914_0.db73acf0.jpg";